import {Chart, ChartType, Plugin} from 'chart.js';
import {Utils} from '@astek/utils';

export type CommentsIndicatorsPluginOptions = {
  color: string;
  imageHeight: number;
  margin: number;
  timestamps: Array<number>;
  image: HTMLImageElement;
}

declare module 'chart.js' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/naming-convention
  interface PluginOptionsByType<TType extends ChartType = ChartType> {
    commentsIndicators: CommentsIndicatorsPluginOptions;
  }
}

export const commentsIndicatorsPlugin: Plugin = {
  id: 'commentsIndicators',
  afterDraw(chart: Chart, args, options: Partial<CommentsIndicatorsPluginOptions>) {
    if (Utils.isNullOrUndefined(options.timestamps)
      || Utils.isNullOrUndefined(options.color)
      || Utils.isNullOrUndefined(options.imageHeight)
      || Utils.isNullOrUndefined(options.margin)
      || Utils.isNullOrUndefined(options.image)) {
      return;
    }
    const ctx = chart.ctx;
    ctx.save();
    // compute display dimensions
    const xScale = chart.scales['x'];
    const yScale = chart.scales['y'];
    const img = options.image;
    const aspectRatio = img.naturalWidth / img.naturalHeight;
    img.height = options.imageHeight;
    img.width = img.height * aspectRatio;
    const radius = img.height / 2.0 + options.margin;

    for (const timestamp of options.timestamps) {
      if (timestamp >= xScale.min && timestamp <= xScale.max) {
        const xPixel = xScale.getPixelForValue(timestamp);
        // draw circle
        ctx.beginPath();
        ctx.arc(xPixel, yScale.top + radius, radius, 0, 2 * Math.PI, false);
        ctx.fillStyle = options.color;
        ctx.fill();
        // draw image
        ctx.drawImage(img,
          xPixel - (img.width / 2),
          yScale.top + options.margin + 1,
          img.width,
          img.height);
        ctx.restore();
      }
    }
  },
};
